var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeleteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-delete",
    transform: "translate(-1295 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 16,
    height: 16,
    transform: "translate(1295 98)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD-25_opsz20",
    d: "M6.285,15.208a1.226,1.226,0,0,1-1.232-1.233V5.288H4.188V4.055h3.4V3.208h3.478v.847h3.4V5.288H13.61v8.687a1.226,1.226,0,0,1-1.233,1.233Zm6.092-9.92H6.285v8.687h6.092Zm-4.73,7.381H8.881V6.576H7.647Zm2.135,0h1.233V6.576H9.783Zm-3.5-7.381v0Z",
    transform: "translate(1293.668 96.792)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deleteIcon.3702945b.svg";
export { ForwardRef as ReactComponent };